import axios from 'axios';

const restApiBaseURL = '/EcoMAIN_WebAPI/api';

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return '';
}

function getUserToken() {
  return `Bearer ${getCookie('sessionToken')}`;
}

export const axiosRestApiPrivate = axios.create({
  baseURL: restApiBaseURL,
  timeout: 60000,
});

axiosRestApiPrivate.interceptors.request.use((config) => {
  const newConfig = config;
  newConfig.data = config.data || {};
  newConfig.headers.Authorization = getUserToken();
  return newConfig;
});
